<div class="full-page w-100 d-flex px-0"  [ngStyle]="{ 'background-image': 'url(' + ('images/login-registration/login-background-image.jpg' | contentAssetImage) + ')' }">
  <!--Left Side-->
  <div class="maintenance-container">
    <img [src]="'images/login-registration/loginpagelogo.png' | contentAssetImage" alt="" class="logo" />
    <!--Right Side-->
    <div class="down-part-maintenance">
      <span class="material-icons logo-maintenance"> engineering </span>
      <h5 class="m-0 title-maintenance">{{ 'maintenance.page.title' | translate }}</h5>
      <p class="text-black font-size-14 m-0" [innerHTML]="'maintenance.page.text' | translate | markdownTranslate"></p>
    </div>
  </div>
</div>
